import { render, staticRenderFns } from "./settings-helper-components-1-main-page.vue?vue&type=template&id=95ea5d58&"
import script from "./settings-helper-components-1-main-page.vue?vue&type=script&lang=ts&"
export * from "./settings-helper-components-1-main-page.vue?vue&type=script&lang=ts&"
import style0 from "./settings-helper-components-1-main-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports